/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplyPenaltyCommand } from '../../models/apply-penalty-command';
import { ApplyPenaltyCommandResult } from '../../models/apply-penalty-command-result';

export interface ApiKpiReportsApplyPenaltyPost$Params {
      body?: ApplyPenaltyCommand
}

export function apiKpiReportsApplyPenaltyPost(http: HttpClient, rootUrl: string, params?: ApiKpiReportsApplyPenaltyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplyPenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsApplyPenaltyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApplyPenaltyCommandResult>;
    })
  );
}

apiKpiReportsApplyPenaltyPost.PATH = '/api/KPIReports/ApplyPenalty';
